import { PairChallenge } from '@era/locations-sdk';
import { ErrorModel } from '@rocksoft/shared';

export interface State {
  code: string | undefined;
  pairChallenge: PairChallenge | undefined;
  isVerifyingCode: boolean;
  isEnrolling: boolean;
  isCodeValid: boolean;
  isCodeValidated: boolean;
  isEnrollmentCompleted: boolean;
  error: ErrorModel | undefined;
}

export const initialState: State = {
  code: undefined,
  pairChallenge: undefined,
  isVerifyingCode: false,
  isCodeValid: false,
  isCodeValidated: false,
  isEnrolling: false,
  isEnrollmentCompleted: false,
  error: undefined,
};
